module.exports = __webpack_public_path__ + "static/media/more.79963a66.svg";